import React from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';

const AnimatedSection = ({
  children,
  id,
  className = '',
  delay = 0
}) => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section
      id={id}
      ref={ref}
      className={`py-16 md:py-24 transition-all duration-700 ${
        isVisible
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-10'
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </section>
  );
};

export default AnimatedSection;